"use client";

import React from "react";
import { Loader, Lock, Mail, CircleAlert as AlertCircle, CircleCheck as CheckCircle2 } from 'lucide-react';
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Link } from "@/components/common/Link";
function LoginForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <Alert className="bg-primary/10 border-primary/20 text-primary">
                <CheckCircle2 className="size-4 text-primary" />
                <AlertDescription className="text-primary font-medium">
                    {successMessage}
                </AlertDescription>
            </Alert>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
            {submitError && <Alert variant="destructive">
                    <AlertCircle className="size-4" />
                    <AlertDescription>
                        {submitError}
                    </AlertDescription>
                </Alert>}

            <div className="space-y-4">
                <FormField control={control} name="email" rules={{
        required: "El correo electrónico o usuario es obligatorio"
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel>Correo electrónico o usuario</FormLabel>
                            <FormControl>
                                <div className="relative">
                                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                                    <Input placeholder="ejemplo@msbiotech.com" className="pl-10" {...field} />
                                </div>
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="password" rules={{
        required: "La contraseña es obligatoria",
        minLength: {
          value: 6,
          message: "La contraseña debe tener al menos 6 caracteres"
        }
      }} render={({
        field
      }) => <FormItem>
                            <div className="flex items-center justify-between">
                                <FormLabel>Contraseña</FormLabel>
                                <Link to="#" className="text-sm font-medium text-primary hover:underline">
                                    ¿Olvidó su contraseña?
                                </Link>
                            </div>
                            <FormControl>
                                <div className="relative">
                                    <Lock className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                                    <Input type="password" placeholder="••••••••" className="pl-10" {...field} />
                                </div>
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="rememberMe" render={({
        field
      }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0 pt-2">
                            <FormControl>
                                <Checkbox checked={field.value} onCheckedChange={field.onChange} />
                            </FormControl>
                            <div className="space-y-1 leading-none">
                                <FormLabel className="font-normal text-muted-foreground cursor-pointer">
                                    Recordarme en este dispositivo
                                </FormLabel>
                            </div>
                        </FormItem>} />
            </div>

            <Button type="submit" disabled={isSubmitting} className="w-full h-11 text-base">
                {isSubmitting ? <>
                        <Loader className="animate-spin mr-2 size-5" />
                        Iniciando sesión...
                    </> : 'Iniciar sesión'}
            </Button>
        </Form>;
}
export default function MemberLogin() {
  return <section id="memberlogin" className="min-h-[80vh] flex items-center justify-center bg-background py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
            {}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-primary/5 blur-[120px]" />
                <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-secondary/30 blur-[120px]" />
            </div>

            <div className="w-full max-w-md relative z-10">
                <div className="text-center mb-8">
                    <Link to="/" className="inline-block mb-6">
                        <img src="/img/logo.png" alt="MS Biotechnology Logo" className="h-10 mx-auto" />
                    </Link>
                    <h1 className="text-3xl font-default font-bold text-foreground tracking-tight">
                        Acceso para Miembros
                    </h1>
                    <p className="mt-2 text-muted-foreground">
                        Plataforma exclusiva para distribuidores y socios
                    </p>
                </div>

                <Card className="border-border/50 shadow-xl bg-background/95 backdrop-blur-sm">
                    <CardHeader className="pb-4">
                        <CardTitle className="text-xl font-default">Iniciar Sesión</CardTitle>
                        <CardDescription>
                            Ingrese sus credenciales para acceder a su cuenta.
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <FormProvider formId="member-login-form" sectionName="MemberLogin" defaultValues={{
            email: "",
            password: "",
            rememberMe: false
          }} submitText="Iniciar sesión" successMessage="Inicio de sesión exitoso. Redirigiendo a su panel..." errorMessage="Error al iniciar sesión. Por favor, verifique sus credenciales.">
                            <LoginForm />
                        </FormProvider>
                    </CardContent>
                    <CardFooter className="flex justify-center border-t border-border/50 pt-6 pb-6">
                        <p className="text-sm text-muted-foreground">
                            ¿No tiene una cuenta?{" "}
                            <Link to="#" className="font-medium text-primary hover:underline">
                                Solicitar acceso
                            </Link>
                        </p>
                    </CardFooter>
                </Card>
            </div>
        </section>;
}